import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import PropTypes from 'prop-types';
import ChartDataLabels from 'chartjs-plugin-datalabels';

function DashboardChart({ data, options, type, className, style }) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    setChartData(data);
    setChartOptions(options);
  }, [data, options]);

  return (
    <Chart
      type={type}
      data={chartData}
      options={chartOptions}
      plugins={[ChartDataLabels]}
      className={className}
      style={style}
    />
  );
}

DashboardChart.propTypes = {
  data: PropTypes.shape({}),
  options: PropTypes.shape({}),
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

DashboardChart.defaultProps = {
  data: {},
  options: {},
  className: '',
  style: {},
};

export default React.memo(DashboardChart);
